// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2P1dr","col":"CardReaderDesc_col__j0zLH","label":"CardReaderDesc_label__1RVhh"};